import { User, Building, Settings, VerifiedIcon, Bell, Lock, AlertCircle, CreditCard, Eye, Globe, Shield, } from "lucide-react";
import { Card } from "primereact/card";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectedProfileSetting, setProfileSetting } from "../../../redux";
import { useTranslation } from "react-i18next";

const ProfileSidebarComponent = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const activeSection = useSelector(selectedProfileSetting);

    const navItems = [
        { id: "general", label: t("profileSidebar.professional.general"), icon: Settings },
        { id: "company", label: t("profileSidebar.professional.companyDetails"), icon: Building },
        { id: "notifications", label: t("profileSidebar.professional.notifications"), icon: Bell },
        { id: "privacy", label: t("profileSidebar.professional.privacy"), icon: Eye },
        // { id: "security", label: t("profileSidebar.professional.security"), icon: Shield },
        { id: "billing", label: t("profileSidebar.professional.billing"), icon: CreditCard },
        // { id: "connected", label: t("profileSidebar.professional.connectedAccounts"), icon: Globe }
    ];
    return (
        <>
            <aside className="md:w-64">
                <Card color={undefined} className="p-2">
                    <nav className="space-y-1">
                        {navItems.map(item => (
                            <button
                                key={item.id}
                                onClick={() => dispatch(setProfileSetting(item.id))}
                                className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm
                      ${activeSection === item.id ? "bg-blue-50 text-blue-700" : "text-gray-600 hover:bg-gray-50"}`}>
                                <item.icon className="h-5 w-5" />
                                {item.label}
                            </button>
                        ))}
                    </nav>
                </Card>
            </aside>
        </>


    );
};

export default ProfileSidebarComponent;